import React from 'react';
import {
	qualification,
	notice,
	reception,
	health,
	fail,
	provide,
	onGoing,
	after,
	control,
	emergency,
	privacy,
} from './data';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container} from '../../../Components/Atom';

const Note = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '유의사항']} />
			<CardSection {...qualification} />
			<CardSection {...notice} />
			<CardSection {...reception} />
			<CardSection {...health} />
			<CardSection {...fail} />
			<CardSection {...provide} />
			<CardSection {...emergency} />
			{/* <CardSection {...onGoing} />
			<CardSection {...after} /> 
			<CardSection {...privacy} />*/}
			<CardSection {...control} />
		</Container>
	);
};

export default Note;
